import { useQuery } from '@tanstack/react-query';
import type { SuburbSearchResult } from '@property-reports/api-contract';

const API_BASE = import.meta.env.VITE_API_URL || '';

async function fetchJson<T>(url: string): Promise<T> {
  const response = await fetch(url, {
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
}

export function useSuburbSearch(query: string) {
  return useQuery({
    queryKey: ['suburbs', 'search', query],
    queryFn: () =>
      fetchJson<SuburbSearchResult[]>(
        `${API_BASE}/api/suburbs?q=${encodeURIComponent(query)}&limit=20`
      ),
    enabled: query.length >= 2, // Only search when at least 2 characters
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });
}
